/**
 * Local Business SEO Data
 * Centralized configuration for local SEO structured data
 */

export const localBusinessData = {
  name: "Jörg Hörmann - Executive Coaching & Finanzcoaching",
  description: "Mobiles Finanzcoaching, Executive Coaching und Outdoor-Coaching in Bayern. Coaching vor Ort beim Kunden, outdoor oder remote – bevorzugt im Umkreis von 140 km um Roth. Executive Coaching deutschlandweit.",
  additionalType: "https://schema.org/ServiceAreaBusiness",
  address: {
    city: "Roth",
    postalCode: "91154",
    region: "Bayern", 
    country: "DE"
  },
  geo: {
    latitude: 49.2401,
    longitude: 11.0967
  },
  phone: "+49-9171-9892118",
  email: "info@joerg-hoermann.de",
  url: "https://joerg-hoermann.de",
  serviceArea: [
    // Kerngebiet (0–30 km)
    "Metropolregion Nürnberg",
    "Landkreis Roth",
    "Roth",
    "Schwabach",
    "Nürnberg",
    "Fürth",
    "Erlangen",
    // Erweiterter Radius (50–140 km)
    "Neumarkt in der Oberpfalz",
    "Weißenburg in Bayern",
    "Ansbach",
    "Ingolstadt",
    "Regensburg",
    "Bamberg",
    "Würzburg",
    "Augsburg",
    "München",
    // Outdoor-Coaching Standorte
    "Rothsee",
    "Fränkisches Seenland",
    "Hilpoltstein",
    "Allersberg",
    "Georgensgmünd",
    // Überregional
    "Mittelfranken",
    "Bayern",
    "Deutschland"
  ],
  openingHours: [
    "Mo-Fr 09:00-18:00"
  ],
  priceRange: "€€€",
  paymentAccepted: [
    "Cash",
    "Invoice", 
    "Bank Transfer"
  ]
} as const;

export const businessServices = [
  {
    name: "Finanzcoaching",
    description: "Individuelles Coaching für finanzielle Ziele, Budgetplanung und Investitionsentscheidungen. Professionelle Begleitung auf dem Weg zur finanziellen Unabhängigkeit.",
    url: "https://joerg-hoermann.de/finanzcoaching",
    areaServed: [
      "Metropolregion Nürnberg", "Landkreis Roth", "Roth", "Schwabach", "Nürnberg", "Fürth", "Erlangen",
      "Neumarkt in der Oberpfalz", "Weißenburg in Bayern", "Ansbach", "Ingolstadt", "Regensburg",
      "Bamberg", "Würzburg", "Augsburg", "München",
      "Mittelfranken", "Bayern", "Deutschland"
    ],
    price: {
      "@type": "Offer",
      "price": "150",
      "priceCurrency": "EUR",
      "priceSpecification": {
        "@type": "PriceSpecification",
        "price": "150",
        "priceCurrency": "EUR",
        "valueAddedTaxIncluded": true,
        "description": "ab 150 € inkl. USt."
      }
    }
  },
  {
    name: "Outdoor-Coaching am Rothsee",
    description: "Walk & Talk Coaching am Rothsee im Fränkischen Seenland. Unser Signature-Format für neue Perspektiven in der Natur. Auch in den Alpen auf Anfrage verfügbar.",
    url: "https://joerg-hoermann.de/outdoor-coaching",
    areaServed: [
      "Rothsee", "Fränkisches Seenland", "Hilpoltstein", "Allersberg",
      "Roth", "Georgensgmünd", "Landkreis Roth", "Schwabach",
      "Nürnberg", "Metropolregion Nürnberg"
    ],
    price: {
      "@type": "Offer",
      "price": "199",
      "priceCurrency": "EUR",
      "priceSpecification": {
        "@type": "PriceSpecification",
        "price": "199",
        "priceCurrency": "EUR",
        "valueAddedTaxIncluded": true,
        "description": "199 € inkl. USt. pro 90-Min. Session"
      }
    }
  },
  {
    name: "Executive Coaching & Katalysator-Führung",
    description: "Katalysator-Führung für Unternehmen und Führungskräfte. Strategische Begleitung, emotionale Intelligenz und nachhaltige Führungsentwicklung. Deutschlandweit verfügbar.",
    url: "https://joerg-hoermann.de/consulting",
    areaServed: [
      "Metropolregion Nürnberg", "Landkreis Roth", "Roth", "Schwabach", "Nürnberg", "Fürth", "Erlangen",
      "Neumarkt in der Oberpfalz", "Ansbach", "Ingolstadt", "Regensburg", "Bamberg", "Würzburg", "Augsburg", "München",
      "Mittelfranken", "Bayern", "Deutschland"
    ],
    price: {
      "@type": "Offer",
      "price": "200",
      "priceCurrency": "EUR",
      "priceSpecification": {
        "@type": "PriceSpecification",
        "price": "200",
        "priceCurrency": "EUR",
        "valueAddedTaxIncluded": false,
        "description": "ab 200 € netto"
      }
    }
  },
];

// Local SEO Keywords for different regions
export const localSEOKeywords = {
  primary: [
    "Finanzcoaching Nürnberg",
    "Executive Coaching Bayern", 
    "Outdoor-Coaching Rothsee",
    "Führungskräfte-Coaching Mittelfranken"
  ],
  secondary: [
    "Finanzberater Erlangen",
    "Business Coach Fürth",
    "Coaching Schwabach",
    "Executive Coaching Augsburg",
    "Walk Talk Coaching Bamberg",
    "Coaching in der Natur Bayern",
    "Finanzplanung Metropolregion Nürnberg",
    "Business Coach Regensburg",
    "Führungskräfte-Coaching Ingolstadt"
  ],
  longTail: [
    "Finanzcoaching Privatpersonen Nürnberg",
    "Outdoor Coaching am Rothsee Hilpoltstein",
    "Walk Talk Coaching Fränkisches Seenland",
    "Outdoor Coaching Rothsee Fränkisches Seenland",
    "Executive Coaching Metropolregion Nürnberg",
    "Walk and Talk Coaching Metropolregion Nürnberg",
    "Finanzberatung für Unternehmen Bayern",
    "Coaching in der Natur Rothsee",
    "Finanzcoaching Schwabach Roth",
    "Executive Coaching Augsburg München",
    "Outdoor Coaching Hilpoltstein Allersberg",
    "Führungskräfte Coaching Würzburg Bayern",
    "Natur-Coaching Fränkisches Seenland"
  ]
} as const;